import { BsThreeDotsVertical } from 'react-icons/bs';
import PropTypes from 'prop-types';

import { colorReferenceApprover, colorReferenceInspector } from '../../../../utils/dataEnum';

import styles from './FakeDayCell.module.scss';

const FakeDayCell = ({ colorsApprover, colorsInspector }) => (
  <div className={styles['day-cell-container']}>
    <div
      className={styles['day-cell-upper-container']}
      style={{
        background: colorsApprover.length
          ? colorsApprover.find((obj) => obj.id === colorReferenceApprover.aprobada).bgColor
          : '#219E66'
      }}
    >
      <button
        aria-label="Acciones"
        className={`${styles['focus-ring']} ${styles.btn}`}
        style={{ color: '#FFFFFF' }}
        type="button"
      >
        <BsThreeDotsVertical />
      </button>

      <p
        className={styles['checkbox-container']}
        style={{
          color: colorsApprover.length
            ? colorsApprover.find((obj) => obj.id === colorReferenceApprover.aprobada).textColor
            : '#FFFFFF'
        }}
      >
        <input
          checked={false}
          className={styles['focus-ring']}
          disabled={false}
          onChange={null}
          type="checkbox"
        />
        1
      </p>
    </div>
    <div
      className={styles['bottom-line']}
      style={{
        background: colorsInspector.length
          ? colorsInspector.find((obj) => obj.id === colorReferenceInspector.actuarInspector).color
          : '#616161'
      }}
    />
  </div>
);

export default FakeDayCell;

FakeDayCell.propTypes = {
  colorsApprover: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
      color: PropTypes.string
    })
  ),
  colorsInspector: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
      color: PropTypes.string
    })
  )
};

FakeDayCell.defaultProps = {
  colorsApprover: [],
  colorsInspector: []
};
